import { render, staticRenderFns } from "./TermlyReportPreviousYears.vue?vue&type=template&id=8580e1e6&scoped=true"
import script from "./TermlyReportPreviousYears.vue?vue&type=script&lang=js"
export * from "./TermlyReportPreviousYears.vue?vue&type=script&lang=js"
import style0 from "./TermlyReportPreviousYears.vue?vue&type=style&index=0&id=8580e1e6&prod&scoped=true&lang=css"
import style1 from "./TermlyReportPreviousYears.vue?vue&type=style&index=1&id=8580e1e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8580e1e6",
  null
  
)

export default component.exports